import xinlidaily from './xinlidaily'
import calendar from './calendar'
import dailylist from './dailylist'

export default [...xinlidaily, ...calendar, ...dailylist]



// WEBPACK FOOTER //
// ./src/router/page/xinlidaily/index.js